export type CorporateLocation = 'pittsburgh' | 'tampa';

export const LOCATION_OPTIONS: { value: CorporateLocation; label: string }[] = [
  { value: 'pittsburgh', label: 'Pittsburgh' },
  { value: 'tampa', label: 'Tampa' },
];

export const SELECTED_LOCATION_KEY = 'corporateLocation';

export function getSelectedLocation(defaultLocation: CorporateLocation = 'pittsburgh'): CorporateLocation {
  const stored = sessionStorage.getItem(SELECTED_LOCATION_KEY);
  if (stored === 'pittsburgh' || stored === 'tampa') return stored;
  return defaultLocation;
}

export function setSelectedLocation(location: CorporateLocation): void {
  sessionStorage.setItem(SELECTED_LOCATION_KEY, location);
}
